import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_PROMO_CODES_DATA, FETCH_PROMO_CODES_EDIT_DATA } from "./actionTypes";
import {
  fetchPromoCodesSuccess,
  fetchPromoCodesFailure,
  fetchPromoCodesEditSuccess,
  fetchPromoCodesEditFailure,
} from "./actions";

function* fetchPromoCodesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/promo-codes",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchPromoCodesSuccess(response.data));
  } catch (error) {
    yield put(fetchPromoCodesFailure(error.message));
  }
}

function* fetchPromoCodesEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/promo-codes/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchPromoCodesEditSuccess(response.data));
  } catch (error) {
    yield put(fetchPromoCodesEditFailure(error.message));
  }
}

export default function* promoCodesSaga() {
  yield takeEvery(FETCH_PROMO_CODES_DATA, fetchPromoCodesDataSaga);
  yield takeEvery(FETCH_PROMO_CODES_EDIT_DATA, fetchPromoCodesEditDataSaga);
}
